module.exports = __webpack_public_path__ + "static/16-b6817595007fb24284a48ab46db68a1c.jpg";